import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    background: "#000",
    degree_selected: 1,
    degrees_name: '°C',
    state_selected: 1,
    zipcode: '',
    dataInfo: [],
    mapInfo: [],
    tableInfo: [
      {
        id: 1,
        city_id: 1,
        zip: '20001',
        gender: 'Female',
        age: '18-20', 
        comorbidities: 'Yes',
        comorbidities_list: [
          {'name': 'Diabetes', 'icon': 'diabetes.png'},
          {'name': 'Asmtha', 'icon': 'asmtha.png'},
          {'name': 'Heart disease', 'icon': 'hearth_disease.png'},
          {'name': 'Hypertension', 'icon': 'hypertension.png'},
        ],
        cough: 'Yes', 
        fever: '38.1', 
        level_risk: '10',
        level_risk_color: 'danger',
        level_risk_color_map: '#dc3545',
        date_created: '2 days ago',
        contact: 'Yes',
        coordinates: [-77.0712866, 38.9545197], 
        country: 'USA',
        _rowVariant: null,
        have_cough: true,
        have_phone: true,
        have_email: true
      },
      { 
        id: 2,
        city_id: 1,
        zip: '20002',
        gender: 'Male',
        age: '20-22', 
        comorbidities: 'No',
        comorbidities_list: [], 
        cough: 'Yes', 
        fever: 'N/A', 
        level_risk: '5',
        level_risk_color: 'warning',
        level_risk_color_map: '#ffc107',
        date_created: '1 hour ago',
        contact: 'Yes',
        coordinates: [-77.0368671, 38.9596727], 
        country: 'USA',
        _rowVariant: null,
        have_cough: true,
        have_phone: false,
        have_email: true
      },
      { 
        id: 3,
        city_id: 1,
        zip: '20003',
        gender: 'Male',
        age: '35-37', 
        comorbidities: 'Yes',
        comorbidities_list: [
          {'name': 'Diabetes', 'icon': 'diabetes.png'},
          {'name': 'Asmtha', 'icon': 'asmtha.png'},
        ], 
        cough: 'Yes', 
        fever: '37.8', 
        level_risk: '8',
        level_risk_color: 'danger',
        level_risk_color_map: '#dc3545',
        date_created: '4 days ago',
        contact: 'No',
        coordinates: [-77.0678971, 38.9246374], 
        country: 'USA',
        _rowVariant: null,
        have_cough: true,
        have_phone: false,
        have_email: false
      },
      { 
        id: 4,
        city_id: 1,
        zip: '20004',
        gender: 'Female',
        age: '18-23', 
        comorbidities: 'Yes',
        comorbidities_list: [
          {'name': 'Asmtha', 'icon': 'asmtha.png'},
        ],  
        cough: 'Yes', 
        fever: '37.6', 
        level_risk: '5',
        level_risk_color: 'warning',
        level_risk_color_map: '#ffc107',
        date_created: '4 days ago',
        contact: 'No',
        coordinates: [-77.0077801, 38.927435], 
        country: 'USA',
        _rowVariant: null,
        have_cough: true,
        have_phone: true,
        have_email: true
      },
      { 
        id: 5,
        city_id: 1,
        zip: '20001',
        gender: 'Male',
        age: '18-23', 
        comorbidities: 'Yes',
        comorbidities_list: [
          {'name': 'Diabetes', 'icon': 'diabetes.png'},
          {'name': 'Asmtha', 'icon': 'asmtha.png'},
          {'name': 'Hypertension', 'icon': 'hypertension.png'},
        ], 
        cough: 'Yes', 
        fever: '36.7', 
        level_risk: '7',
        level_risk_color: 'warning',
        level_risk_color_map: '#ffc107',
        date_created: '4 days ago',
        contact: 'No',
        coordinates: [-77.0230168, 38.9328486], 
        country: 'USA',
        _rowVariant: null,
        have_cough: true,
        have_phone: false,
        have_email: true
      },
      { 
        id: 6,
        city_id: 1,
        zip: '20005',
        gender: 'Male',
        age: '18-23', 
        comorbidities: 'Yes',
        comorbidities_list: [
          {'name': 'Diabetes', 'icon': 'diabetes.png'},
          {'name': 'Heart disease', 'icon': 'hearth_disease.png'},
          {'name': 'Hypertension', 'icon': 'hypertension.png'},
        ], 
        cough: 'Yes', 
        fever: '36.7', 
        level_risk: '7',
        level_risk_color: 'warning',
        level_risk_color_map: '#ffc107',
        date_created: '4 days ago',
        contact: 'No',
        coordinates: [-77.0265599, 38.9025884], 
        country: 'USA',
        _rowVariant: null,
        have_cough: true,
        have_phone: false,
        have_email: false
      },
      { 
        id: 7,
        city_id: 1,
        zip: '20002',
        gender: 'Male',
        age: '18-23', 
        comorbidities: 'Yes',
        comorbidities_list: [
          {'name': 'Diabetes', 'icon': 'diabetes.png'},
          {'name': 'Asmtha', 'icon': 'asmtha.png'},
          {'name': 'Heart disease', 'icon': 'hearth_disease.png'},
          {'name': 'Hypertension', 'icon': 'hypertension.png'},
        ], 
        cough: 'Yes', 
        fever: '3.0', 
        level_risk: '9',
        level_risk_color: 'danger',
        level_risk_color_map: '#dc3545',
        date_created: '4 days ago',
        contact: 'No',
        coordinates: [-77.0341551, 38.8997708], 
        country: 'USA',
        _rowVariant: null,
        have_cough: true,
        have_phone: false,
        have_email: false
      },
      { 
        id: 8,
        city_id: 1,
        zip: '20006',
        gender: 'Female',
        age: '18-20', 
        comorbidities: 'Yes',
        comorbidities_list: [
          {'name': 'Diabetes', 'icon': 'diabetes.png'},
          {'name': 'Asmtha', 'icon': 'asmtha.png'},
          {'name': 'Heart disease', 'icon': 'hearth_disease.png'},
          {'name': 'Hypertension', 'icon': 'hypertension.png'},
        ], 
        cough: 'No', 
        fever: '37.2', 
        level_risk: '10',
        level_risk_color: 'danger',
        level_risk_color_map: '#dc3545',
        date_created: '2 days ago',
        contact: 'Yes',
        coordinates: [-77.0711111, 38.9544444], 
        country: 'USA',
        _rowVariant: null,
        have_cough: false,
        have_phone: true,
        have_email: true
      },
      { 
        id: 9,
        city_id: 1,
        zip: '20002',
        gender: 'Male',
        age: '20-22', 
        comorbidities: 'No',
        comorbidities_list: [], 
        cough: 'No', 
        fever: 'N/A', 
        level_risk: '5',
        level_risk_color: 'warning',
        level_risk_color_map: '#ffc107',
        date_created: '1 hour ago',
        contact: 'Yes',
        coordinates: [-77.0366666, 38.9333333], 
        country: 'USA',
        _rowVariant: null,
        have_cough: false,
        have_phone: false,
        have_email: true
      },
      { 
        id: 10,
        city_id: 1,
        zip: '20005',
        gender: 'Male',
        age: '35-37', 
        comorbidities: 'Yes',
        comorbidities_list: [
          {'name': 'Diabetes', 'icon': 'diabetes.png'},
          {'name': 'Asmtha', 'icon': 'asmtha.png'},
          {'name': 'Heart disease', 'icon': 'hearth_disease.png'},
        ], 
        cough: 'No', 
        fever: '37.3', 
        level_risk: '10',
        level_risk_color: 'danger',
        level_risk_color_map: '#28a745',
        date_created: '4 days ago',
        contact: 'No',
        coordinates: [-77.0678971, 38.9246374], 
        country: 'USA',
        _rowVariant: null,
        have_cough: false,
        have_phone: false,
        have_email: false
      },
      { 
        id: 11,
        city_id: 1,
        zip: '20001',
        gender: 'Female',
        age: '18-23', 
        comorbidities: 'Yes',
        comorbidities_list: [
          {'name': 'Asmtha', 'icon': 'asmtha.png'},
        ], 
        cough: 'No', 
        fever: '36.9', 
        level_risk: '2',
        level_risk_color: 'success',
        level_risk_color_map: '#28a745',
        date_created: '4 days ago',
        contact: 'No',
        coordinates: [-77.0077777, 38.955777], 
        country: 'USA',
        _rowVariant: null,
        have_cough: false,
        have_phone: true,
        have_email: true
      },
      { 
        id: 12,
        city_id: 1,
        zip: '20007',
        gender: 'Male',
        age: '18-23', 
        comorbidities: 'No',
        comorbidities_list: [], 
        cough: 'No', 
        fever: '35.7', 
        level_risk: '2',
        level_risk_color: 'success',
        level_risk_color_map: '#28a745',
        date_created: '4 days ago',
        contact: 'No',
        coordinates: [-77.0222222, 38.9333333], 
        country: 'USA',
        _rowVariant: null,
        have_cough: false,
        have_phone: false,
        have_email: true
      },
      { 
        id: 13,
        city_id: 1,
        zip: '20008',
        gender: 'Male',
        age: '18-23', 
        comorbidities: 'No',
        comorbidities_list: [], 
        cough: 'No', 
        fever: '36.3', 
        level_risk: '1',
        level_risk_color: 'success',
        level_risk_color_map: '#28a745',
        date_created: '4 days ago',
        contact: 'No',
        coordinates: [-77.0277777, 38.8887766], 
        country: 'USA',
        _rowVariant: null,
        have_cough: false,
        have_phone: false,
        have_email: false
      },
      { 
        id: 14,
        city_id: 1,
        zip: '20006',
        gender: 'Male',
        age: '18-23', 
        comorbidities: 'Yes',
        comorbidities_list: [
          {'name': 'Diabetes', 'icon': 'diabetes.png'},
        ], 
        cough: 'No', 
        fever: '36.3', 
        level_risk: '3',
        level_risk_color: 'success',
        level_risk_color_map: '#28a745',
        date_created: '4 days ago',
        contact: 'No',
        coordinates: [-77.0333333, 38.8888888], 
        country: 'USA',
        _rowVariant: null,
        have_cough: false,
        have_phone: false,
        have_email: false
      },
    ],
    states_cities: [
      {'value': null, 'text': 'All'},
      {'value': 10, 'text': 'New York'},
      {'value': 10, 'text': 'California'},
      {'value': 10, 'text': 'Illinois'},
      {'value': 10, 'text': 'Texas'},
      {'value': 10, 'text': 'Pennsylvania'},
      {'value': 10, 'text': 'Arizona'},
      {'value': 10, 'text': 'Florida'},
      {'value': 10, 'text': 'Indiana'},
      {'value': 10, 'text': 'Ohio'},
      {'value': 10, 'text': 'North Carolina'},
      {'value': 10, 'text': 'Michigan'},
      {'value': 10, 'text': 'Tennessee'},
      {'value': 10, 'text': 'Massachusetts'},
      {'value': 1, 'text': 'Washington'},
      {'value': 10, 'text': 'Colorado'},
      {'value': 10, 'text': 'District of Columbia'},
      {'value': 10, 'text': 'Maryland'},
      {'value': 10, 'text': 'Kentucky'},
      {'value': 10, 'text': 'Oregon'},
      {'value': 10, 'text': 'Oklahoma'},
      {'value': 10, 'text': 'Wisconsin'},
      {'value': 10, 'text': 'Nevada'},
      {'value': 10, 'text': 'New Mexico'},
      {'value': 10, 'text': 'Missouri'},
      {'value': 10, 'text': 'Virginia'},
      {'value': 10, 'text': 'Georgia'},
      {'value': 10, 'text': 'Nebraska'},
      {'value': 10, 'text': 'Minnesota'},
      {'value': 10, 'text': 'Kansas'},
      {'value': 10, 'text': 'Louisiana'},
      {'value': 10, 'text': 'Hawaii'},
      {'value': 10, 'text': 'Alaska'},
      {'value': 10, 'text': 'New Jersey'},
      {'value': 10, 'text': 'Idaho'},
      {'value': 10, 'text': 'Alabama'},
      {'value': 10, 'text': 'Iowa'},
      {'value': 10, 'text': 'Arkansas'},
      {'value': 10, 'text': 'Utah'},
      {'value': 10, 'text': 'Rhode Island'},
      {'value': 10, 'text': 'Mississippi'},
      {'value': 10, 'text': 'South Dakota'},
      {'value': 10, 'text': 'Connecticut'},
      {'value': 10, 'text': 'South Carolina'},
      {'value': 10, 'text': 'New Hampshire'},
      {'value': 10, 'text': 'North Dakota'},
      {'value': 10, 'text': 'Montana'},
      {'value': 10, 'text': 'Delaware'},
      {'value': 10, 'text': 'Maine'},
      {'value': 10, 'text': 'Wyoming'},
      {'value': 10, 'text': 'West Virginia'},
      {'value': 10, 'text': 'Vermont'}
    ],
    markerList: [],
    geoInfo: {
      "type": "FeatureCollection",
      "features": [
        {
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [-77.0712866, 38.9545197],
            },
            "properties":{
                "people": 1
            }
        }
      ]
    },
    PeopleTired_data: {
      "Stats": [
          {
              "people": 4,
              "feel": "Feel well"
          },
          {
              "people": 19,
              "feel": "Feel unwell"
          }
      ],
      "TotalPeopleReported": 23
    },
    PeopleFeelUnwell_data: {
      "Stats": [
          {
              "people": 1,
              "status": "Feel tired or exhausted",
              "color": "#50cca8"
          },
          {
              "people": 5,
              "status": "Feel ill",
              "color": "#f57a6e"
          }
      ],
      "TotalPeopleReported": 6
    },  
    GeneralSymptoms_data: {
      "Stats": [
        {
            "people": 3,
            "symptom": "Shortness of breath"
        },
        {
            "people": 1,
            "symptom": "Cough"
        },
        {
            "people": 8,
            "symptom": "Aches"
        }
      ],
      "TotalPeopleReported": 12
    },  
    PeopleFeelingUnwell_data: {
      "Stats": [
        {
            "people": 5,
            "date": "2020-04-03"
        },
        {
            "people": 1,
            "date": "2020-04-06"
        },
        {
            "people": 13,
            "date": "2020-04-07"
        }
      ],
      "TotalPeopleReported": 19
    },
    PeopleCoMorbitidites_data: {
      "Stats": [
          {
              "people": 2,
              "illness": "Hypertension"
          },
          {
              "people": 1,
              "illness": "Diabetes"
          },
          {
              "people": 1,
              "illness": "Asthma"
          }
      ],
      "TotalPeopleReported": 4
    },  
    Cough_data: {
      "Stats": [
          {
              "people": 2,
              "level": "dry"
          },
          {
              "people": 4,
              "level": "productive with phlegm"
          }
      ],
      "TotalPeopleReported": 6
    },
  },
  mutations: {
    markerSelected(state, index) {
      index--;
      console.log(index)
      if (state.markerList[index] !== undefined) {
        state.markerList.splice(index, 1)
        state.tableInfo[index]._rowVariant = null
        return;
      }

      state.tableInfo[index]._rowVariant = 'info'
      state.markerList[index] = (state.tableInfo[index])
    },
    searchFilter(state, string) {
      const text = textToLower(string);
      const info = state.tableInfo;
      
      if (string !== '') {
        state.markerList = [];
        state.state_selected = 1;
        state.zipcode = '';
      }

      const filtered = info.filter(function(item) {
        let gender = textToLower(item.gender);
        return gender.indexOf(text) > -1 || 
          item.age.indexOf(text) > -1 ||
          item.level_risk.indexOf(text) > -1;
      });
      
      setTimeout(()=>{
        state.dataInfo = filtered;
        state.mapInfo = filtered;
      })
    },
    zipFilter(state, zipcode) {
      const string = zipcode;
      const info = state.tableInfo;
      state.markerList = [];      
      state.state_selected = null;
      
      const filtered = info.filter(function(item) {
        console.log(string, item)
        return item.zip.indexOf(string) > -1
      });      

      setTimeout(()=>{
        state.dataInfo = filtered;
        state.mapInfo = filtered;
      }, 20)

    },
    cities_filter(state, index) {
      const info = state.tableInfo;

      const filtered = info.filter(function(item) {
        return item.city_id == index
      });
      
      state.markerList = [];
      state.state_selected = index;
      state.dataInfo = filtered;
      state.mapInfo = filtered;
    },
    change_degrees(state, degree) {
      state.degree_selected = degree
    },
    cretaPoint(state) {
      state.dataInfo = [];
      state.tableInfo = [];

/*       const southWest = {'lat':40.744656, 'lng': -74.005966};
      const northEast = {'lat': 34.052234, 'lng': -118.243685}; */
      const southWest = {'lat': 38.949364, 'lng': -77.0871677}
      const northEast = {'lat': 38.8405742, 'lng': -76.9373107}
      const lngSpan = northEast.lng - southWest.lng;
      const latSpan = northEast.lat - southWest.lat;
      const markers = [];
      const geoMarker = []

      // Create some markers
      for (let index = 1; index <= 1000; index++) {
        const location = [southWest.lng + lngSpan * Math.random(), southWest.lat + latSpan * Math.random()];
        const rand01 = Math.round(Math.random())
        const gender = ['Male', 'Female'];
        const yesNo = ['Yes', 'No']
        const yesNoValue = yesNo[rand01]
        const firstAge = Math.floor(Math.random() * (70 - 18) + 18);
        const secondAge = firstAge + 2;
        const zipCode = (Math.floor(Math.random() * (20456 - 20001) + 20001)).toString();
        const fever = (Math.random() * (36.5 - 38.3) + 38.3).toFixed(2);
        const feverF = parseFloat((fever * 9/5) + 32).toFixed(2);
        const levelRisk = (Math.floor(Math.random() * 10 + 1)).toString();
        const coughSound = (Math.floor(Math.random() * 9 + 1)).toString();
        const timeAgo = Math.floor(Math.random() * 30 + 1);
        const hoursDays = ['hours', 'days']
        const dateCreated = timeAgo + ' ' + hoursDays[rand01] + ' ago'
        const randIndex = Math.floor(Math.random() * 6);
        const comorbidities = []

        const comorbiditiesList = [
            {'name': 'Diabetes', 'icon': 'diabetes.png'},
            {'name': 'Asthma', 'icon': 'asthma.png'},
            {'name': 'Heart disease', 'icon': 'hearth_disease.png'},
            {'name': 'Hypertension', 'icon': 'hypertension.png'}
        ]

        const indexSaved = []
        if (rand01 == 0)
          for (let index = 0; index < randIndex; index++) {
            let randItem = Math.floor(Math.random() * 3);

            if (indexSaved[randItem] == undefined) {
              comorbidities.push(comorbiditiesList[randItem])
              indexSaved[randItem] = 1;
            }
          }

        let levelRiskColor = 'success'
        let levelRiskColorMap = '#28a745'

        if (levelRisk > 4 && levelRisk < 8) {
          levelRiskColor = 'warning'
          levelRiskColorMap = '#ffc107'
        } else if (levelRisk >= 8) {
          levelRiskColor = 'danger'
          levelRiskColorMap = '#dc3545'
        }


        const data = {
          id: index,
          city_id: 1,
          zip: zipCode,
          gender: gender[rand01],
          age: firstAge + '-' + secondAge, 
          comorbidities: yesNoValue,
          comorbidities_list: comorbidities,
          cough: yesNoValue, 
          cough_sound: coughSound,
          fever: fever, 
          fever_f: feverF,
          level_risk: levelRisk,
          level_risk_color: levelRiskColor,
          level_risk_color_map: levelRiskColorMap,
          date_created: dateCreated,
          contact: yesNoValue,
          coordinates: location, 
          country: 'USA',
          _rowVariant: null,
          have_cough: rand01,
          have_phone: true,
          have_email: true
        };

        const geoData = {
          "type": "Feature",
          "geometry": {
              "type": "Point",
              "coordinates": location,
          },
          "properties":{
              "people": 1
          }
        }
        
        markers.push(data);
        geoMarker.push(geoData)
      }

      state.dataInfo = markers;
      state.tableInfo = markers;
      state.geoInfo.features = geoMarker;
    }
  },
  actions: {
  },
  modules: {
  }
})

function textToLower(string) {
  return string.trim().toLowerCase();
}
